import {Box, Button, Flex} from '@chakra-ui/react'
import PropTypes from 'prop-types'

const HoveringContinue = ({t, children, onClick}) => {
  return (
    <Box
      position="absolute"
      bottom={5}
      bg="white"
      border="1px"
      borderRadius="full"
      borderColor="mld.neutral.200"
      width="95%"
      px={5}
      py={4}
      mt={4}
      mx={-2}
      boxShadow="0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
    >
      <Flex justify="space-between" align="center">
        {children}
        <Button
          className="fs-unmask"
          colorScheme="black"
          variant="primary"
          size="md"
          onClick={onClick}
          borderRadius="full"
          px={4}
        >
          {t('modal.buttons.continue')}
        </Button>
      </Flex>
    </Box>
  )
}

HoveringContinue.propTypes = {
  t: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default HoveringContinue
